import type { ICard } from '@/components/ui/swimlane/types';

type ItemTitleSizeOptions = 'small' | 'medium' | 'large' | 'extra-large';

export const ITEM_TITLE_SIZE: Record<ItemTitleSizeOptions, number> = {
  small: 12,
  medium: 14,
  large: 16,
  'extra-large': 18,
} as const;

export const getItemTitleFontSize = (labelSize: ItemTitleSizeOptions): number => {
  return ITEM_TITLE_SIZE[labelSize];
};

export const getDateLabel = ({
  bucketLabel,
  startDate,
  endDate,
}: Pick<ICard, 'bucketLabel' | 'startDate' | 'endDate'>): string => {
  if (bucketLabel) {
    return bucketLabel;
  } else if (startDate && endDate) {
    return `${startDate} - ${endDate}`;
  } else if (startDate) {
    return startDate;
  } else if (endDate) {
    return endDate;
  }

  return '';
};

export const getHasProgress = ({ progress }: Pick<ICard, 'progress'>): boolean =>
  typeof progress === 'number' && !Number.isNaN(progress);

export const getParentTitle = ({
  parentId,
  parentTitle,
}: Pick<ICard, 'parentId' | 'parentTitle'>): string => (parentId && parentTitle) || '';

export const getHasParentTitle = ({ parentId }: Pick<ICard, 'parentId'>): boolean =>
  Boolean(parentId);

export const getHasLabels = (
  { labels }: Pick<ICard, 'labels'>,
  {
    isCompact,
    areLabelsEnabledInCompactSL,
  }: {
    isCompact: boolean;
    areLabelsEnabledInCompactSL: boolean;
  },
): boolean => {
  if (!labels?.length) {
    return false;
  }

  // If not compact theme, always show labels
  if (!isCompact) {
    return true;
  }

  // If compact theme, show labels only if the feature flag allows it
  return areLabelsEnabledInCompactSL;
};

export const getHasDescription = (
  { description }: Pick<ICard, 'description'>,
  { isItemDescriptionVisible }: { isItemDescriptionVisible: boolean },
): boolean => Boolean(isItemDescriptionVisible && description);
